var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promotionContainer u-bg-white",class:{ '-seimei': _vm.isSeimei }},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.promotionData)}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-615ea584","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/PromotionContainer.vue
// module id = null
// module chunks = 